import { render, staticRenderFns } from "./PresentationSettings.vue?vue&type=template&id=54ebf461&scoped=true"
import script from "./PresentationSettings.vue?vue&type=script&lang=js"
export * from "./PresentationSettings.vue?vue&type=script&lang=js"
import style0 from "./PresentationSettings.vue?vue&type=style&index=0&id=54ebf461&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ebf461",
  null
  
)

export default component.exports